import { matchPath } from 'react-router'
import { useAppSelector } from 'hooks/reduxHooks'
import { BUSINESS_TRAVELLER_ROOT_ROUTE } from 'components/App/Routes/routeConstants'
import useWhiteLabelAppConfig from 'hooks/useWhiteLabelAppConfig'

function useOnboardingStatusResolved(): boolean {
  const { isApp } = useWhiteLabelAppConfig()
  const pathname = useAppSelector(state => state.router.location.pathname)
  const onboardingStatus = useAppSelector(state => state.businessTraveller.onboarding?.employeeOnboardingStatus)

  const isLandingPage = !!matchPath(pathname, { path: `/:regionCode${BUSINESS_TRAVELLER_ROOT_ROUTE}`, exact: true })

  // Do not wait for onboarding status to be resolved when it is in mobile app or not in landing page
  if (isApp) return true
  if (!isLandingPage) return true

  return onboardingStatus === 'DISMISSED' || onboardingStatus === 'COMPLETED'
}

export default useOnboardingStatusResolved
